export const LynxModalConstant = {
  height: 464,
  width: 660,
};
